import React from "react";
import KernelVaultInput from "./KernelVaultInput";

/**
 * Simple Withdraw Component
 * Uses KernelVaultInput for consistent UI across all vaults with Kernel Design System
 */
export interface WithdrawProps {
  // Vault info
  vaultTokenSymbol: string;
  outputTokenSymbol: string;
  vaultTokenIcon?: string;
  outputTokenIcon?: string;

  // Balances
  vaultTokenBalance: number;
  outputTokenBalance: number;

  // Converted amount (calculated by vault hook)
  convertedAmount: string;
  exchangeRateDisplay?: string;

  // State
  isConnected: boolean;
  isApproved?: boolean; // for withdraw approval
  isSupportedChain?: boolean;

  // Callbacks
  onWithdraw: (amount?: string) => void;
  onApprove?: (amount?: string) => void; // for withdraw approval
  onAmountChange?: (amount: string) => void;
  onTokenSelect?: (token: string) => void;
  onOutputTokenSelect?: (token: string) => void;

  // Optional
  vaultType?: "airdrop" | "highGrowth" | "stable" | "yield" | "cryptanium";
  disclaimer?: React.ReactNode;
  checkInputConstraints?: (amount: string) => string;
  enableTokenSelection?: boolean;
  enableOutputTokenSelection?: boolean;
}

const Withdraw = ({
  vaultTokenSymbol,
  outputTokenSymbol,
  vaultTokenIcon,
  outputTokenIcon,
  vaultTokenBalance,
  outputTokenBalance,
  convertedAmount,
  exchangeRateDisplay,
  isConnected,
  isApproved,
  isSupportedChain = true,
  onWithdraw,
  onApprove,
  onAmountChange,
  onTokenSelect,
  onOutputTokenSelect,
  vaultType,
  disclaimer,
  checkInputConstraints,
  enableTokenSelection = false, // For withdraw, typically single token
  enableOutputTokenSelection = false,
}: WithdrawProps) => {
  return (
    <div className="w-full px-1 sm:px-3">
      <KernelVaultInput
        type="withdraw"
        inputTokenSymbol={vaultTokenSymbol}
        inputTokenBalance={vaultTokenBalance}
        inputTokenIcon={vaultTokenIcon}
        outputTokenSymbol={outputTokenSymbol}
        outputTokenBalance={outputTokenBalance}
        outputTokenIcon={outputTokenIcon}
        convertedAmount={convertedAmount}
        exchangeRateDisplay={exchangeRateDisplay}
        isConnected={isConnected}
        isApproved={isApproved}
        isSupportedChain={isSupportedChain}
        onAmountChange={onAmountChange}
        onTokenSelect={onTokenSelect}
        onOutputTokenSelect={onOutputTokenSelect}
        onWithdraw={onWithdraw}
        onApprove={onApprove}
        checkInputConstraints={checkInputConstraints}
        disclaimer={disclaimer}
        enableTokenSelection={enableTokenSelection}
        enableOutputTokenSelection={enableOutputTokenSelection}
        vaultType={vaultType}
      />
    </div>
  );
};

export default Withdraw;
